import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task } from "ember-concurrency";

export default class ModalsLoadBalancersCreate extends Component {
  @service intl;
  @service current;
  @service modal;
  @service cost;

  get task() {
    return this.args.params.task;
  }

  get loadBalancerCost() {
    return this.cost.forLoadBalancer();
  }

  dataCenters = Object.freeze([{ value: "Falkenberg" }, { value: "Stockholm" }]);

  name;
  selectedDataCenter = "Falkenberg";

  onFormChange = ({ name, dataCenter }) => {
    this.name = name;
    this.selectedDataCenter = dataCenter;
  };

  submitTask = task(async () => {
    let task = this.task;
    let name = this.name;
    let selectedDataCenter = this.selectedDataCenter;

    await task.perform(name, selectedDataCenter);
    this.modal.close();
  });
}
